import { Currency } from "@redotech/money/currencies";
import { z } from "zod";

export const subscriptionDeliveryProfileSettingsSchema = z.object({
  enabled: z.boolean().optional(),
  deliveryProfileId: z.string().optional(),
  shippingMethod: z
    .object({
      name: z.string(),
      price: z.object({ amount: z.string(), currency: z.enum(Currency) }),
    })
    .optional(),
});
export type SubscriptionDeliveryProfileSettings = z.infer<
  typeof subscriptionDeliveryProfileSettingsSchema
>;

export const subscriptionDeliveryProfileSettingsDefault = {
  enabled: false,
  deliveryProfileId: undefined,
  shippingMethod: {
    name: "Standard shipping",
    price: { amount: "0", currency: Currency.USD },
  },
} as const;
